import axios from '../../plugins/axios';
import { Message } from 'element-ui';

export const product_bundles_module = {
    state: ()=> ({
        pending: false,
        loadingMore: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            filter: {
                tags: [],
                status: [],
                indexed: [],
                featured: [],
                searchedTerm: "",
            },
            allFilters:[],
            searchedKeyword:'',
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_product_bundles_request(state, loadingType){

            if(loadingType == 'new'){

                state.pending = true;

            }else if(loadingType == 'more'){

                state.loadingMore = true;

            }

        },
        fetch_product_bundles_success(state, payload){

            if(payload.loadData == 'new'){

                state.data.data = payload.product_bundles.data.map((listedBundle) => {

                    listedBundle.bundle_items = listedBundle.bundle_items.map((listedItem) => {

                        listedItem.item_details = JSON.parse(listedItem.item_details);

                        return listedItem;

                    });

                    listedBundle.tags = listedBundle.tags.map(tag=>{

                        return tag.name;

                    });

                    listedBundle.keywords = listedBundle.keywords.map(keyword=>{

                        return keyword.name;

                    });

                    return listedBundle;

                });

            }

            if(payload.loadData == 'more'){

                let moreBundles = payload.product_bundles.data.map((listedBundle) => {

                    listedBundle.bundle_items = listedBundle.bundle_items.map((listedItem) => {

                        listedItem.item_details = JSON.parse(listedItem.item_details);

                        return listedItem;

                    });

                    listedBundle.tags = listedBundle.tags.map(tag=>{

                        return tag.name;

                    });

                    listedBundle.keywords = listedBundle.keywords.map(keyword=>{

                        return keyword.name;

                    });

                    return listedBundle;

                });

                moreBundles.forEach(element => {

                    state.data.data.push(element);

                });

            }

            state.data.current_page = payload.product_bundles.current_page;
            state.data.last_page = payload.product_bundles.last_page;
            state.pending = false;
            state.loadingMore = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_product_bundles_failure(state, payload){

            state.data.data = [];
            state.pending = false;
            state.loadingMore = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message;

        },
        add_product_bundles_list(state,payload){

            payload.bundle_items = payload.bundle_items.map((listedItem) => {

                listedItem.item_details = JSON.parse(listedItem.item_details);

                return listedItem;

            });

            payload.tags = payload.tags.map((tag) => {

                return tag.name;

            });

            payload.keywords = payload.keywords.map((keyword) => {

                return keyword.name;

            });

            state.data.data.unshift(payload);
            
        },
        update_product_bundles_list(state,payload){

            if(payload.field == "status"){

                state.data.data[payload.recordIndex].isActive = payload.productBundle.isActive

                if(state.data.filter.status != 0){

                    if((state.data.filter.status[0] == 'hide') && (payload.productBundle.isActive == 1) || 
                    (state.data.filter.status[0] == 'active') && (payload.productBundle.isActive == 0)){
    
                        state.data.data = state.data.data.filter((bundle) => bundle.id != payload.productBundle.id);
    
                    }
    
                }

            }else if(payload.field == "name"){
                
                let productBundleIndex = state.data.data.findIndex((listedProductBundle) => listedProductBundle.id == payload.productBundle.id);

                if(productBundleIndex != -1){
    
                    state.data.data[productBundleIndex].name = payload.productBundle.name
                    state.data.data[productBundleIndex].slug = payload.productBundle.slug

                }

            }else{

                state.data.data[payload.recordIndex] = payload.productBundle;

            }

        },
        find_and_update_product_bundle(state,payload){

            let index = state.data.data.findIndex((dataItem) => dataItem.id == payload.productBundle.id);

            if(index != -1){

                state.data.data[index] = payload.productBundle

            }

        },
        delete_product_bundles_list(state,payload){

            state.data.data.splice(payload,1);

        },
        update_bundle_review_status(state,payload){

            state.data.data[payload.bundle_index].reviews[payload.review_index] = payload.review

        },
        product_bundles_bulk_action(state,payload){
            
            if(payload.action == 'delete'){

                state.data.data = state.data.data.filter((bundle)=>{

                    if(!payload.listIds.includes(bundle.id)){
                        
                        return bundle

                    }

                });

            }else if(payload.action == 'statusChange'){

                state.data.data.forEach((bundle) =>{

                    if(payload.listIds.includes(bundle.id)){

                        bundle.isActive = payload.status

                    }

                });

            }else if(payload.action == 'featured'){

                state.data.data = state.data.data.filter((productBundle)=>{

                    if(payload.listIds.includes(productBundle.id)){

                        productBundle.isFeatured = payload.selection

                        return productBundle

                    }else{

                        return productBundle
                        
                    }

                });

            }
            
        },
        update_product_bundle_filters(state,payload){
        
            state.data.filter.status = payload.status;
            state.data.filter.indexed = payload.indexed;
            state.data.filter.featured = payload.featured;
            state.data.filter.tags = payload.tags;
            
        },
        update_product_bundle_allFilters(state,payload){

            state.data.allFilters = payload

        },
        remove_product_bundle_filters(state){

            state.data.filter = {
                tags: [],
                indexed: [],
                status: [],
                featured: [],
                searchedTerm: "",
            }

            state.data.allFilters = []
            
        },
        update_searched_keyword(state,payload){

            state.data.filter.searchedTerm = payload.keyword

        },
        remove_product_bundle_search(state){

            state.data.filter.searchedTerm = ''

            state.data.allFilters = []

        },
        remove_searched_keyword(state){

            state.data.searchedKeyword = ''
            
        },
        CLEAR_MODULE(state){

            state.pending = false
            state.loadingMore = false;
            state.message = null
            state.success = null
            state.error = null

            state.data.filter = {
                tags: [],
                status: [],
                indexed: [],
                featured: [],
                searchedTerm: "",
            }
            state.data.allFilters = [];
            
            state.data.current_page = 1
            state.data.data = []
            state.data.last_page = null,
            state.data.searchedKeyword = ''

        }
    },
    actions: {
        async fetchProductBundlesRequest({commit},{size, page, loadData}){

            let tags = this.state.product_bundles_module.data.filter.tags;
            let status = this.state.product_bundles_module.data.filter.status;
            let searchedTerm = this.state.product_bundles_module.data.filter.searchedTerm;
            let indexed = this.state.product_bundles_module.data.filter.indexed[0];
            let featured = this.state.product_bundles_module.data.filter.featured[0];

            commit('fetch_product_bundles_request',loadData);
            try{
                let res = await axios.get(`/product-bundle/all`,{
                    params:{
                        tags: tags,
                        status: status[0],
                        search: searchedTerm.length > 0 ? searchedTerm : null,
                        indexed: indexed ? indexed == 'indexed' ? 1 : 0 : null,
                        featured: featured ? featured == 'featured' ? 1 : 0 : null,
                        offset: size,
                        page: page
                    }
                });
                if(res.data.status_code == '1761'){

                    res.data.loadData = loadData

                    commit('fetch_product_bundles_success', res.data);

                }
            }catch(ex){

                Message({
                    type: 'error',
                    showClose: true,
                    message: ex.response ? ex.response.data.message : ex.message,
                });

                commit('fetch_product_bundles_failure', {error: ex, message: ex}); 

            }

        }
    },
    getters: {
        product_bundles(state){

            return state.data.data;

        },
        filters(state){

            return state.data.filter;

        },
        allFilters(state){

            return state.data.allFilters;

        },
        keyword(state){

            return state.data.searchedKeyword;

        },
        searchedTerm(state){

            return state.data.filter.searchedTerm

        },
        isPending(state){

            return state.pending;

        },
        isLoadingMore(state){

            return state.loadingMore;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        message(state){

            return state.message;

        },
        error:(state)=>state.error
    },


}